import router from '../../router'
import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'

export default {
  state: {
    PredictionPlace: null,
    UserAddress: null,
    LatLng: null,
    ChangeLocation: null,
    DistanceInfo: null,
    SuggestionDetail: null,
    DistanceBranch: null
  },
  mutations: {
    setPlacePrediction (state, payload) {
      state.PredictionPlace = payload
    },
    setUserAddress (state, payload) {
      state.UserAddress = payload
    },
    setLatLng (state, payload) {
      state.LatLng = payload
    },
    setChangeLocation (state, payload) {
      state.ChangeLocation = payload
    },
    setDistanceInfo (state, payload) {
      state.DistanceInfo = payload
    },
    setSuggestionDetail (state, payload) {
      state.SuggestionDetail = payload
    },
    setDistanceBranch (state, payload) {
      state.DistanceBranch = payload
    }
  },
  actions: {
    setPlacePrediction ({commit}, payload) {
      commit('setPlacePrediction', payload)
    },
    setUserAddress ({commit}, payload) {
      commit('setUserAddress', payload)
    },
    setLatLng ({commit}, payload) {
      commit('setLatLng', payload)
    },
    setChangeLocation ({commit, dispatch}, payload) {
      let location = payload.location
      let restaurant = JSON.parse(localStorage.getItem('restaurant'))
      dispatch('calculateDistanceOSRM', {
        origin_coordinates: [payload.branch.latitude, payload.branch.longitude],
        origin_address: payload.branch.address,
        destination_address: location.address,
        destination_coordinates: [location.lat, location.lng]
            }).then((distance) => {
              let noDistance = true
              if(distance !== null && distance !== undefined){
                  noDistance = false
                  dispatch('saveDeliveryfee',{
                    payload: payload,
                    restaurant: restaurant,
                    distance: distance
                  }).then((res) => {
                    commit('setChangeLocation', payload)
                    commit('setSuggestionDetail', res.setSuggestionDetail)
                    commit('setDistanceBranch', res.setDistanceBranch)
                  })
              }
              if(noDistance){
                dispatch('calculateDistanceMatrix', {
                  origin_coordinates: [payload.branch.latitude, payload.branch.longitude],
                  origin_address: payload.branch.address,
                  destination_address: location.address,
                  destination_coordinates: [location.lat, location.lng]
                }).then((distance) => {
                  dispatch('saveDeliveryfee',{
                    payload: payload,
                    restaurant: restaurant,
                    distance: distance
                  }).then((res) => {
                    commit('setChangeLocation', payload)
                    commit('setSuggestionDetail', res.setSuggestionDetail)
                    commit('setDistanceBranch', res.setDistanceBranch)
                  })
                })
              }
            })
    },
    getDeliveryFee (_context, payload) {
      return axios({
        method: 'POST',
        url: API_MASTER_DATA + 'restaurants/' + payload.restaurant + '/branches/' + payload.branch + '/deliveryfee',
        data: {
          latitude: payload.location.lat,
          longitude: payload.location.lng,
          total_amount: payload.total,
          distance: payload.distance
        }
      })
    },  
    getDistanceInfo ({ commit, dispatch }, payload) {
      return dispatch('getDeliveryFee', payload).then((response) => {
        var data = {}
        if (response.data.meta.status == 200) {
          if (response.data.data.dis_metre == 0) {
            data = { price: 0, dis_metre: 0, status: 'over' }
          } else {
            data = { price: response.data.data.price, dis_metre: response.data.data.dis_metre, status: 'normal' }
          }
        } else if (response.data.meta.status == 404 && response.data.meta.responseCode == 'M01') {
          data = { price: response.data.data.minimumPrice, dis_metre: response.data.data.dis_metre, status: 'minimum' }
        } else if (response.data.meta.status == 404 && response.data.meta.responseCode == 'M04') {
          data = { price: response.data.data.minimumDistance, dis_metre: response.data.data.dis_metre, status: 'over' }
        }
        commit('setDistanceInfo', data)
        return data
      })
    },
    async calculateDistance({ dispatch }, payload) {
      const distanceOSRM = await dispatch('calculateDistanceOSRM', payload)
      if (Number.isFinite(distanceOSRM)) return distanceOSRM
      const distanceMatrix = await dispatch('calculateDistanceMatrix', payload)
      return distanceMatrix
    },
    async calculateDistanceOSRM({commit}, payload){
      return await axios({
        method: 'GET',
        url: API_MASTER_DATA + 'map/calculateosrm/' + `${payload.origin_coordinates[1]}/${payload.origin_coordinates[0]}/${payload.destination_coordinates[1]}/${payload.destination_coordinates[0]}`,
      })
      .then((distance) => {
        
        return (distance.data.meta.status === 200)? distance.data.data.distance: null
      }).catch(() => {
        return null
      })
    },
    async saveDeliveryfee({commit}, payload){
      return await axios({
        method: 'POST',
        url: API_MASTER_DATA + 'restaurants/' + payload.restaurant.uuid + '/branches/' + payload.payload.branch.id + '/deliveryfee-suggestion',
        data: {
          distance: payload.distance
        }
      }).then((response) => {
        if (response.data.meta.status == 200) {
          return {
            setSuggestionDetail: response.data.data,
            setDistanceBranch: response.data.data.distance
          }
        } else {
          return {
            setSuggestionDetail: null,
            setDistanceBranch: response.data.data.dis_metre
          }
        }
      }).catch(() =>{
        return {
          setSuggestionDetail: null,
          setDistanceBranch: null
        }
      })
    },
    async calculateDistanceMatrix ({commit}, payload) {

      const getDistanceMatrix = (service, data) => new Promise((resolve, reject) => {
        service.getDistanceMatrix(data, (response, status) => {
          var distanceMatrix = 0
          var distance = []
          if(status == 'OK') {

            for (var i = 0; i < response.originAddresses.length; i++) {
              var results = response.rows[i].elements
              for (var j = 0; j < results.length; j++) {
                var element = results[j]
                if (element.status == 'OK') {
                  distance.push(element.distance.value)
                }
              }
            }

            // distance = [2636, 50057, 10346, 42346]

            distance = distance.sort((a, b) => { return a - b })

            const n_distance = (distance.length > 0) ? distance.length : 0

            // กรณีจำนวนระยะทางทั้งหมดเลขคู่
            if(n_distance%2 == 0) {
              const left_median_idx = (n_distance/2) - 1
              const right_median_idx = ((n_distance/2)+1) - 1
              // ถ้าค่าเฉลี่ยตรงกลางลบกัน >= 1700เมตร ให้คืนค่าตรงกลางทางซ้าย
              if((distance[right_median_idx]-distance[left_median_idx]) >= 1700) {
                distanceMatrix = distance[0]
              } else {
                // ถ้าค่าเฉลี่ยตรงกลางลบกัน >= 1700เมตร ให้หาค่าเฉลี่ยตรงกลาง
                distanceMatrix = (distance[right_median_idx] + distance[left_median_idx]) / 2
                // เอาค่าเฉลี่ยตรงกลางเทียบกับระยะทางสั้นที่สุดว่า >= 1700เมตร ถ้ามากกว่าให้เอาระยะที่สั้นที่สุด
                if((distanceMatrix-distance[0]) >= 1700) {
                  distanceMatrix = distance[0]
                }
              }

              // console.log(distance, n_distance, distance[right_median_idx], distance[left_median_idx], distance[right_median_idx]-distance[left_median_idx])

            // กรณีจำนวนระยะทางทั้งหมดเลขคี่
            } else {
              distanceMatrix = distance[0]
              if (n_distance > 1) {
                // ค่าตรงกลางของระยะทางทั้งหมด
                const median_idx = ((n_distance+1)/2) - 1
                // ถ้าค่าเฉลี่ยตรงกลางลบกับระยะทางที่สั้นที่สุด < 1700 ให้เอาค่าตรงกลาง
                if ((distance[median_idx]-distance[0]) < 1700) {
                  distanceMatrix = distance[median_idx]
                }
              }
            }

          }
          distanceMatrix = (distance.length > 0) ? distanceMatrix : 0
          resolve(distanceMatrix)
        })
      })
      var origin = new google.maps.LatLng(payload.origin_coordinates[0], payload.origin_coordinates[1])
      var destination = new google.maps.LatLng(payload.destination_coordinates[0], payload.destination_coordinates[1])
      var service = new google.maps.DistanceMatrixService()
      const distance = await getDistanceMatrix(service, {
        origins: [origin, payload.origin_address],
        destinations: [destination, payload.destination_address],
        travelMode: 'DRIVING',
        avoidHighways: true,
        avoidTolls: true
      })
      // console.log(distance)
      return distance
    }
  },
  getters: {
    UserAddress (state) {
      return state.UserAddress
    },
    PredictionPlace (state) {
      return state.PredictionPlace
    },
    LatLng (state) {
      return state.LatLng
    },
    ChangeLocation (state) {
      return state.ChangeLocation
    },
    DistanceInfo (state) {
      return state.DistanceInfo
    },
    SuggestionDetail (state) {
      return state.SuggestionDetail
    },
    DistanceBranch (state) {
      return state.DistanceBranch
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/map/index.js